/** Valor de fecha que puede venir de Firestore (Timestamp) o ser Date. */
export type FirestoreDate = Date | { toDate(): Date } | { seconds: number; nanoseconds: number };

/** Pasarela / método de pago. */
export enum PaymentGatewayType {
  CARDNET = "CARDNET",
  AZUL = "AZUL",
  TPAGO = "TPAGO",
  PAYPAL = "PAYPAL",
  MANUAL_BANK = "MANUAL_BANK",
  CASH = "CASH",
  STRIPE = "STRIPE",
}

/** Estado de un pago. */
export enum PaymentStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
  MANUAL_VERIFICATION = "MANUAL_VERIFICATION",
}

/** Registro de pago. */
export interface Payment {
  id: string;
  orderId?: string;
  financingRequestId?: string;
  userId: string;
  userName?: string;
  userEmail?: string;
  amount: number;
  currency: string;
  paymentDate: FirestoreDate;
  status: PaymentStatus;
  gatewayType: PaymentGatewayType;
  transactionId?: string;
  reference?: string;
  voucherUrl?: string;
  voucherVerified?: boolean;
  processingFee?: number;
  netAmount?: number;
  notes?: string;
  createdAt: FirestoreDate;
  updatedAt: FirestoreDate;
}

/** Filtros para listado de pagos. */
export interface PaymentFilters {
  status?: PaymentStatus;
  gatewayType?: PaymentGatewayType;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}
